import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useStaticQuery, graphql } from 'gatsby'
import { useGatsbyPluginFusejs } from 'react-use-fusejs'
import { groupBy, map, times, random, uniqBy } from 'lodash'
import RelatedRecipeCard from './RelatedRecipeCard'

const RelatedRecipes = ({ product }) => {
  const recipes = product.relatedRecipes || []

  const data = useStaticQuery(graphql`
    {
      fusejs {
        index
        data
      }
      allWpProduct {
        edges {
          node {
            title
          }
        }
      }
    }
  `)

  const result = useGatsbyPluginFusejs(product.title, data.fusejs)

  const mappedResults = map(result, ({ item }) => ({
    ...item,
  }))

  const groupedResults = groupBy(
    mappedResults,
    (item) => item.key
  )

  let searchRecipes = groupedResults.recipes

  searchRecipes = searchRecipes?.filter(
    (recipe) => !recipes.includes(recipe)
  )

  searchRecipes?.slice(0, 5 - recipes.length)

  searchRecipes = map(searchRecipes, (node) => ({
    id:
      node?.id ||
      times(16, () => random(16).toString(36)).join(''),
    imageAlt: node?.title,
    image: node?.image || '',
    slug: node?.slug || '',
    title: node?.title || '',
  }))

  let relatedRecipes =
    recipes.length < 5
      ? [...recipes, ...searchRecipes]
      : recipes

  relatedRecipes = uniqBy(relatedRecipes, 'slug').slice(0, 5)

  // Editable WordPress fields
  const heading = product?.relatedRecipesHeading || ''
  const subheading = product?.relatedRecipesSubheading || ''

  return (
    <div className='px-7.5 md:px-0 limit-1440'>

      <div className='border-b border-dorot-purple border-solid pt-4.5 mb-7.5 md:mb-[53px] md:pb-3.5 md:mx-18 lg:mx-0 lg:mb-10'>

        {/* Editable Heading */}
        {heading && (
          <h2 className='font-gelica font-bold text-dorot-purple text-_1642 md:text-_3642'>
            {heading}
          </h2>
        )}

        {/* Editable Subheading */}
        {subheading && (
          <p
            className='mt-2 font-gelica text-dorot-purple text-base md:text-lg'
            dangerouslySetInnerHTML={{ __html: subheading }}
          />
        )}

      </div>

      <Swiper
        breakpoints={{
          320: {
            slidesPerView: 2,
            spaceBetween: 22,
          },
          768: {
            slidesPerView: 3.5,
            spaceBetween: 40,
            centeredSlides: true,
            initialSlide: (recipes.length - 1) / 2,
          },
          1025: {
            slidesPerView: 5,
            spaceBetween: 30,
          },
        }}
        className=''
      >
        {relatedRecipes.map((recipe) => (
          <SwiperSlide
            key={recipe.id}
            className='rounded-[10px] overflow-hidden dorot-shadow !h-auto md:w-[230px] lg:w-[229px]'
          >
            <RelatedRecipeCard recipe={recipe} />
          </SwiperSlide>
        ))}
      </Swiper>

    </div>
  )
}

export default RelatedRecipes